import { render, staticRenderFns } from "./DepartureTransfers.vue?vue&type=template&id=2ac7dd8b"
import script from "./DepartureTransfers.vue?vue&type=script&lang=js"
export * from "./DepartureTransfers.vue?vue&type=script&lang=js"
import style0 from "./DepartureTransfers.vue?vue&type=style&index=0&id=2ac7dd8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports